/**
 * MemberSections — the segmented per-member sections of a review-handoff
 * GROUP preparation request (CLAUDE.md §34.11): the meeting voice note and,
 * per member, the Adviser's notes and the New Business Assistant's
 * "prepared" tick. The tick is a working aid only and gates nothing.
 * togglePrepared stays in PrepRequestDetail.jsx (it writes through
 * updatePrepRequest) and is passed in. Extracted verbatim (step P3 of the
 * PrepRequestDetail decomposition, audit §6.2); the moved block keeps its
 * original indentation, and the `prep.memberSections &&` guard stays at the
 * call site.
 */

import { nb } from './NotebookPaper';

export default function MemberSections({ prep, isNB, busy, togglePrepared }) {
  return (
          <>
            {prep.memberSections.voiceNoteUrl && (
              <div style={{ ...nb.fieldRow, display: 'block' }}>
                <span style={{ ...nb.label, display: 'block', marginBottom: '4px' }}>
                  Meeting voice note
                </span>
                {/* Attached as-is — no transcription or AI summary exists
                    for this note (§34.11); the assistant plays it. */}
                <audio controls src={prep.memberSections.voiceNoteUrl} style={{ width: '100%', maxWidth: '420px' }} />
              </div>
            )}
            <div style={nb.divider}>— Preparation per client —</div>
            {(prep.memberSections.sections || []).map((section) => (
              <div
                key={section.reviewClientId}
                style={{
                  borderLeft: `4px solid ${section.prepared ? 'var(--cp-success)' : '#d4565a'}`,
                  padding: '6px 10px',
                  margin: '10px 0',
                  background: section.prepared ? 'rgba(46, 196, 182, 0.06)' : 'transparent',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                  <span style={{ ...nb.readValue, fontSize: '20px' }}>{section.name}</span>
                  {section.isEntity && (
                    <span style={{
                      fontFamily: "'Kalam', cursive",
                      fontSize: '10px',
                      fontWeight: 700,
                      letterSpacing: '0.04em',
                      padding: '1px 7px',
                      borderRadius: '8px',
                      background: 'rgba(15, 76, 117, 0.1)',
                      color: 'var(--cp-primary)',
                    }}>ENTITY</span>
                  )}
                  <label style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '5px', fontFamily: "'Kalam', cursive", fontSize: '12px', color: section.prepared ? 'var(--cp-success)' : 'var(--cp-text-muted)', cursor: isNB ? 'pointer' : 'default' }}>
                    <input
                      type="checkbox"
                      checked={!!section.prepared}
                      disabled={!isNB || busy}
                      onChange={() => togglePrepared(section.reviewClientId)}
                      style={{ accentColor: 'var(--cp-success)' }}
                    />
                    prepared
                  </label>
                </div>
                <div style={{ ...nb.summaryText, whiteSpace: 'pre-wrap', marginTop: '2px' }}>
                  {section.notes || <span style={{ color: '#8a7a55' }}>No notes for this client.</span>}
                </div>
              </div>
            ))}
          </>
  );
}
